import { create } from "zustand";

export type AccPipelinePhase =
  | "idle"
  | "resolving"
  | "translating"
  | "loading_viewer"
  | "extracting"
  | "analyzing"
  | "ready"
  | "error";

interface AccPipelineState {
  active: boolean;
  phase: AccPipelinePhase;
  percent: number;
  message: string;
  /** Non-fatal outcome (e.g. zero evaluable elements after extraction). */
  warning: string | null;
  setStep: (phase: AccPipelinePhase, percent: number, message: string) => void;
  reset: () => void;
  setError: (message: string) => void;
  complete: (warning?: string) => void;
}

const initial = {
  active: false,
  phase: "idle" as AccPipelinePhase,
  percent: 0,
  message: "",
  warning: null as string | null,
};

export const useAccPipelineStore = create<AccPipelineState>(set => ({
  ...initial,

  setStep: (phase, percent, message) => {
    console.info(`[Vera:ACC] ${percent}% — ${message} (phase=${phase})`);
    set({
      active: phase !== "idle" && phase !== "ready",
      phase,
      percent: Math.min(100, Math.max(0, Math.round(percent))),
      message,
      warning: null,
    });
  },

  reset: () => set({ ...initial }),

  setError: message => {
    console.error(`[Vera:ACC] Pipeline error: ${message}`);
    set({
      active: false,
      phase: "error",
      percent: 0,
      message,
      warning: null,
    });
  },

  complete: warning => {
    console.info("[Vera:ACC] 100% — Analysis complete", warning ?? "");
    set({
      active: false,
      phase: "ready",
      percent: 100,
      message: warning ?? "Analysis complete",
      warning: warning ?? null,
    });
  },
}));
